import { FC } from 'react';
// import { format } from 'date-fns';
import cn from 'classnames';

export interface DateFormatProps {
  date: string;
  className?: string;
}

export const DateFormat: FC<DateFormatProps> = ({ date, className }) => {
  const formattedDate = new Intl.DateTimeFormat([], {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(date));

  return <span className={cn('mb-4 text-md', className)}>{formattedDate}</span>;
};

/**
 * With Date-fns
 */

// export interface DateFormatProps {
//   date: string;
//   className?: string;
// }
// export const DateFormat: FC<DateFormatProps> = ({ date, className }) => {
//   const parsedDate = new Date(date);

//   const formattedDate = format(parsedDate, 'dd.MM.yyyy');
//   return <span className={cn('mb-4 text-md', className)}>{formattedDate}</span>;
// };

//, {
//   locale: navigator.language === 'uk' ? uk : undefined,
// }
